import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";
import { Formik, Form, Field } from "formik";

import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

import FormikSemanticDropdown from "../forms/formik/FormikSemanticDropdown.jsx";
import FormikActionsPanel from "../forms/formik/FormikActionsPanel.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class AddUserToResourceForm extends PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    onFormikSubmit: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onInviteByEmail: PropTypes.func,
    renderMessage: PropTypes.func.isRequired,
    violationErrors: PropTypes.object,
    groups: PropTypes.array,
    entity: PropTypes.object,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "users.user_panel",
    disabled: false
  };

  constructor(props) {
    super(props);

    this.initialValues = {
      user: null,
      sudo: ""
    };
  }

  // -- VALIDATION -- //

  validationSchema = () => {
    // const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      user: Yup.mixed(), // will be required once implemented on the api side
      projectGroup: Yup.mixed() // will be required once implemented on the api side
    });
  };

  // -- RENDER -- //

  getSudoRoles = () => {
    const { copyKey, copy } = this.props;

    return [
      { key: "admin", text: copy(`${copyKey}.sudo_roles.admin`), value: true },
      {
        key: "standard",
        text: copy(`${copyKey}.sudo_roles.standard`),
        value: false
      }
    ];
  };

  getUsers = () => {
    const { groups, copyKey, copy } = this.props;

    return groups.map(item => {
      return {
        key: item.name,
        text: copy(`${copyKey}.groups.${item.name}`),
        value: item["@id"]
      };
    });
  };

  render() {
    const {
      onReset,
      onCancel,
      onFormikSubmit,
      onInviteByEmail,
      renderMessage,
      disabled,
      violationErrors,
      entity,
      copyKey,
      copy
    } = this.props;

    // temp until api update
    const canAddUsers = true;

    // bail early if base permissions are not met
    if (!canAddUsers) {
      return null;
    }

    return (
      <Formik
        initialValues={this.initialValues} // required by semantic-ui react
        validateOnMount={true}
        validationSchema={this.validationSchema()}
        onSubmit={onFormikSubmit}
      >
        {formikProps => {
          return (
            <Fragment>
              <Header as="h3">
                {copy(`${copyKey}.add_user_by_existing.title`)}
              </Header>
              <Segment secondary>
                <p>{copy(`${copyKey}.add_user_by_existing.description`)}</p>
                {renderMessage(formikProps)}
                <Form className="ui form">
                  <div className="equal width fields">
                    <Field
                      name="user"
                      placeholder={copy(`${copyKey}.user_placeholder`)}
                      label={copy(`${copyKey}.user_label`)}
                      options={this.getUsers()}
                      required
                      selection
                      disabled={disabled}
                      apiErrors={violationErrors}
                      component={FormikSemanticDropdown}
                    />
                    <Field
                      name="sudo"
                      placeholder={copy(`${copyKey}.sudo_placeholder`)}
                      label={copy(`${copyKey}.sudo_label`)}
                      options={this.getSudoRoles()}
                      required
                      selection
                      disabled={disabled}
                      apiErrors={violationErrors}
                      component={FormikSemanticDropdown}
                    />
                  </div>
                  {onInviteByEmail && (
                    <p>
                      {copy(`${copyKey}.add_by_or`)}{" "}
                      <a onClick={onInviteByEmail} className="show-pointer">
                        {copy(`${copyKey}.add_user_by_email.link`)}
                      </a>
                    </p>
                  )}
                  <FormikActionsPanel
                    onCancel={onCancel}
                    reset={true}
                    onReset={onReset}
                    submit={true}
                    useSubmitModal={true}
                    modalCopy={copy(`${copyKey}.modals`)}
                    panelCopy={copy(`${copyKey}.actions_panel`)}
                    entity={entity}
                  />
                </Form>
              </Segment>
            </Fragment>
          );
        }}
      </Formik>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(AddUserToResourceForm);
